import { render, staticRenderFns } from "./AppHeaderOther.vue?vue&type=template&id=7b121437&scoped=true&"
import script from "./AppHeaderOther.vue?vue&type=script&lang=js&"
export * from "./AppHeaderOther.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderOther.vue?vue&type=style&index=0&id=7b121437&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b121437",
  null
  
)

export default component.exports